module.exports = __webpack_public_path__ + "img/CA.5d08ccab.svg";